import Seo from "../components/Seo";
import PageHero from "../components/site/PageHero";
import DonateButton from "../components/site/DonateButton";
import { ContactForm } from "../components/site/Forms";
import { IMAGES } from "../lib/images";
import { useReveal } from "../lib/useReveal";
import { HeartHandshake, Megaphone, Handshake } from "lucide-react";

const WAYS = [
  {
    icon: HeartHandshake,
    title: "Give",
    text: "A gift of any size supports our charitable purposes. Donations are processed securely through our official JustGiving page.",
  },
  {
    icon: Megaphone,
    title: "Share",
    text: "Tell others about our mission. Sharing our work with your community, church or workplace helps us reach people who can help.",
  },
  {
    icon: Handshake,
    title: "Partner",
    text: "Charities, churches, businesses and community groups: if our missions align, we would love to explore working together.",
  },
];

export default function GetInvolved() {
  const ref = useReveal();
  return (
    <div ref={ref}>
      <Seo
        title="Get Involved"
        path="/get-involved"
        description="Support Mount Moriah Relief: give through our JustGiving page, volunteer your time, share our mission, or partner with us."
      />
      <PageHero
        eyebrow="Get Involved"
        title="Be part of the provision"
        image={IMAGES.volunteers.src}
        imageAlt={IMAGES.volunteers.alt}
      >
        <p>
          Whether you give, volunteer, share or partner with us — you help bring hope, relieve
          hardship and restore dignity.
        </p>
      </PageHero>

      <section className="py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid gap-8 md:grid-cols-3">
            {WAYS.map((w) => (
              <article key={w.title} className="reveal bg-white border border-sandstone p-8 lg:p-10">
                <w.icon size={28} strokeWidth={1.5} className="text-gold" aria-hidden="true" />
                <h2 className="mt-6 font-serif text-2xl font-semibold text-charcoal">{w.title}</h2>
                <p className="mt-3 text-sm text-charcoal/75 leading-relaxed">{w.text}</p>
              </article>
            ))}
          </div>
          <div className="mt-12 reveal">
            <DonateButton testId="involved-donate-button">Donate via JustGiving</DonateButton>
          </div>
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-white border-t border-sandstone" aria-labelledby="volunteer-heading">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 reveal">
            <p className="text-xs tracking-[0.25em] uppercase font-semibold text-gold mb-4">Volunteer</p>
            <h2 id="volunteer-heading" className="font-serif text-3xl sm:text-4xl font-medium text-forest tracking-tight leading-snug">
              Offer your time and skills
            </h2>
            <p className="mt-6 text-charcoal/80 leading-relaxed">
              Volunteers strengthen everything we do — from administration and fundraising to
              community outreach. Tell us a little about yourself and how you would like to help,
              and we will be in touch.
            </p>
            <p className="mt-4 text-sm text-charcoal/60 leading-relaxed">
              We only ask for the information needed to make initial contact. Your details are
              handled under our privacy notice and never published.
            </p>
          </div>
          <div className="lg:col-span-7 reveal">
            <ContactForm kind="volunteer" />
          </div>
        </div>
      </section>
    </div>
  );
}
